__turbopack_context__.v({
  "about": "CategoryAbout-module-scss-module__zQn0Eq__about",
  "appear-slide-left": "CategoryAbout-module-scss-module__zQn0Eq__appear-slide-left",
  "bounceTwice": "CategoryAbout-module-scss-module__zQn0Eq__bounceTwice",
  "content": "CategoryAbout-module-scss-module__zQn0Eq__content",
  "fade-in-bottom": "CategoryAbout-module-scss-module__zQn0Eq__fade-in-bottom",
  "fade-in-left": "CategoryAbout-module-scss-module__zQn0Eq__fade-in-left",
  "fade-in-right": "CategoryAbout-module-scss-module__zQn0Eq__fade-in-right",
  "fadeIn": "CategoryAbout-module-scss-module__zQn0Eq__fadeIn",
  "flexContainer": "CategoryAbout-module-scss-module__zQn0Eq__flexContainer",
  "heading": "CategoryAbout-module-scss-module__zQn0Eq__heading",
  "image": "CategoryAbout-module-scss-module__zQn0Eq__image",
  "link": "CategoryAbout-module-scss-module__zQn0Eq__link",
  "loader": "CategoryAbout-module-scss-module__zQn0Eq__loader",
  "puff-in-center": "CategoryAbout-module-scss-module__zQn0Eq__puff-in-center",
  "puff-in-left": "CategoryAbout-module-scss-module__zQn0Eq__puff-in-left",
  "pulse": "CategoryAbout-module-scss-module__zQn0Eq__pulse",
  "pulse-contact": "CategoryAbout-module-scss-module__zQn0Eq__pulse-contact",
  "shake-bottom": "CategoryAbout-module-scss-module__zQn0Eq__shake-bottom",
  "slide-again": "CategoryAbout-module-scss-module__zQn0Eq__slide-again",
  "slide-in-right": "CategoryAbout-module-scss-module__zQn0Eq__slide-in-right",
  "stepContent-entrance": "CategoryAbout-module-scss-module__zQn0Eq__stepContent-entrance",
  "text": "CategoryAbout-module-scss-module__zQn0Eq__text",
  "word": "CategoryAbout-module-scss-module__zQn0Eq__word",
  "wrapper": "CategoryAbout-module-scss-module__zQn0Eq__wrapper",
});
